import { message } from 'antd'
import { last } from 'lodash'
import { renameFile } from '../../../../../HttpRequests/modelFiles'
import { resetSelectedItemPath } from '../../../State/selectedItemPath'
import modalProps from '../modalProps'
import handleException from '../../../../../Core/Helpers/handleException'

export default (values) => async (dispatch, getState) => {

  const { currentDirectoryPath } = getState().modules.FileManager

  const extention = last(values.current.split('.'))

  const data = {
    current_path: `${currentDirectoryPath}/${values.current}`,
    new_path: `${currentDirectoryPath}/${values.name}.${extention}`,
  }

  try {

    await renameFile({ data })

    message.success('File Renamed')

    dispatch(resetSelectedItemPath())

    modalProps().onClose(true)

  } catch (error) {

    handleException(error)

  }
 
}
